module.exports = __webpack_public_path__ + "img/menu05.395f5da4.svg";